import type { FC, ReactNode } from 'react'
import type { ProjectSummary } from '@/types'

import MainContainer from '@/components/generals/main-container'
import SectionHeading from '@/components/generals/section-heading'
import ProjectFeature from '@/components/projects/project-feature'

interface SelectedWorkProps {
    projects: Array<ProjectSummary>
}

const SelectedWork: FC<SelectedWorkProps> = ({ projects }): ReactNode => {
    const [lead, ...rest] = projects

    if (!lead) return null

    return (
        <MainContainer as='section' id='work' aria-labelledby='work-title' className='pb-24 md:pb-36'>
            <SectionHeading
                id='work-title'
                index='01'
                label='Selected work'
                title={<>Software for real constraints, <em className='text-brand'>shown</em> in full.</>}
                description='Each project is written up as a case study: the problem, the architecture, the trade-offs and what was learned.'
                action={{ href: '/projects', label: 'All projects' }}
            />

            <div className='mt-12 flex flex-col gap-20 md:mt-16 md:gap-28'>
                <ProjectFeature project={lead} index={1} layout='wide' priority />

                {rest.length > 0 && (
                    <div className='grid grid-cols-1 gap-20 md:grid-cols-12 md:gap-x-8'>
                        {rest.map((project, index) => (
                            <ProjectFeature
                                key={project.slug}
                                project={project}
                                index={index + 2}
                                className={index === 0 ? 'md:col-span-5' : 'md:col-span-6 md:col-start-7 md:mt-28'}
                            />
                        ))}
                    </div>
                )}
            </div>
        </MainContainer>
    )
}

export default SelectedWork
